var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pointer accent_color",on:{"click":_vm.getDetail}},[_vm._v(" "+_vm._s(_vm.referenceNumber)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }